import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";

function Home(props) {
  return (
    <div>
      Home Page
    </div>
  );
}

export default Home;
